import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { Store, select } from '@ngrx/store';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { takeUntil } from 'rxjs/operators';
import { getAppHoldingsNames } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { Subject } from 'rxjs';
import { HoldingsNames } from 'src/app/modules/acbcr/common/models/holdings.models';

@Component({
  selector: 'app-incasari-search',
  templateUrl: './incasari-search.component.html',
  styleUrls: ['./incasari-search.component.scss'],
})
export class IncasariSearchComponent implements OnInit, OnDestroy {
  @Output() searchResult = new EventEmitter();

  incasariSearchForm;
  holdingsNames: HoldingsNames[];
  showHint = true;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private helperDataService: HelperDataService,
    private store: Store<ApplicationState>
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(select(getAppHoldingsNames))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: HoldingsNames[]) => {
        this.holdingsNames = response;
      });
    this.incasariSearchForm = new UntypedFormGroup({
      data_inceput: new UntypedFormControl(null),
      data_sfarsit: new UntypedFormControl(null),
      exploatatie: new UntypedFormControl(null),
      chitanta: new UntypedFormControl(null),
    });
  }

  onSubmitted() {
    this.searchResult.emit(this.incasariSearchForm.value);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  searchHoldings(event) {
    if (event.term.length >= 4) {
      this.showHint = false;
    } else {
      this.showHint = true;
    }
  }

  clearHoldings() {
    this.showHint = true;
  }

  resetSearch() {
    this.incasariSearchForm.reset();
    this.onSubmitted();
  }

  onStartDateChanged(event) {
    if (this.incasariSearchForm) {
      this.incasariSearchForm.controls.data_inceput.setValue(event);
    }
  }

  onEndDateChanged(event) {
    if (this.incasariSearchForm) {
      this.incasariSearchForm.controls.data_sfarsit.setValue(event);
    }
  }
}
